export default {
  name: "Prestige",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/logo-color.webp`,
  products: [
    {
      id: "prestige",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/en/product_forward_prestige.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/fr/product_forward_prestige.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "Prestige is an object of national pride, an icon, a cultural symbol. It is one of the most important and dominant brands in Haiti.",
        fr: "La bière Prestige est une fierté nationale, une icône, un symbole culturel. C'est l'une des marques les plus importantes et emblématiques d'Haïti.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/en/information_render_bottle_330ml_prestige.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/fr/information_render_bottle_330ml_prestige.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/en/information_nft_bottle_330ml_prestige.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/prestige/fr/information_nft_bottle_330ml_prestige_fr.webp`,
          },
          name: {
            en: "Bottle 355ml",
            fr: "Bouteille 355ml",
          },
        },
      ],
    },
  ],
};
